import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TabularModel } from '../../shared/models/tabularmodel';
import { environment } from '../../../environments/environment.prod';
import { KeyValuePair } from '../../shared/models/keyvaluepairModel';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';
import { EnvironmentLoaderService } from './environment-loader.service';

@Injectable({
  providedIn: 'root',
})
export class GenModelService {
  private http = inject(HttpClient);
  private envLoaderSerive = inject(EnvironmentLoaderService);

  // baseUrl = environment.apiUrl;
  companyHiringId = localStorage.getItem('companyHiringTypeId');
  private digitalTags$ = new BehaviorSubject<any[]>([]);
  private skills$ = new BehaviorSubject<any[]>([]);
  digitalTags = this.digitalTags$.asObservable();
  skills = this.skills$.asObservable();
  private sub = new Subject<any>();
  chipSub = new Subject<any>();
  vendorId = 5004;
  baseUrlECMS: string = environment.ecmsPartnerHubGateWayUrl;
  baseUrlIntap: string = environment.partnerHubUrlInTap;

  // updateDigitalTags(data: KeyValuePair[]) {
  //   this.digitalTags$.next(data)
  // }
  setClearEvent() {
    this.sub.next(null);
  }
  // get clearEvent(){
  //    return this.sub.asObservable();
  // }

  // updateskills(data: KeyValuePair[]) {
  //     this.skills$.next(data)
  //   }

  // chip_removeParent(closebtn) {
  //     closebtn.target.parentNode.remove();
  // }

  // //for post top banner
  // getReqAPIData(reqId) {
  //     return this.http.get<any>(this.baseUrl + 'getRequisitionForPosting/' +  reqId);
  // }

  // getPostingGenModel(companyHiringTypeId: number) {
  //     return this.http.get<GenModel>(this.baseUrl + 'getGenModelStructure/Posting/' +  companyHiringTypeId);
  // }

  // editGenModelStructure(obj: any) {
  //     return this.http.post<GenModel>(this.baseUrl + 'editGenModelStructure', obj);
  //     // return this.http.post<GenModel>('./assets/json/posting.json',obj);
  // }

  getPublishingChannelData() {
    return this.http.get<TabularModel>('./assets/json/publish.json');
  }

  // getRequisitionGenModel(companyHiringTypeId: number) {

  //     // switch(type){
  //     //     case 'IL': return this.http.get<GenModel>('../../assets/json/requisition.json');
  //     //     case 'BPM': return this.http.get<GenModel>('../../assets/json/requisition-bpm.json');
  //     //     case 'Fresher': return this.http.get<GenModel>('../../assets/json/requisition-fresher.json');
  //     // }
  //     return this.http.get<GenModel>(this.baseUrl + 'getGenModelStructure/Requisition/' +  companyHiringTypeId);
  //     //  return this.http.get<GenModel>('../../assets/json/requisition.json');
  // }

  getEducationTypeData() {
    // return this.http.get<GenModel>('http://10.152.136.26:8081/savePublication');
    return this.http.get<KeyValuePair[]>('./assets/json/educationType.json');
  }
  getfieldOfEducationData(_id: number) {
    // return this.http.get<GenModel>('http://10.152.136.26:8081/savePublication');
    return this.http.get<KeyValuePair[]>('./assets/json/fieldOfEducation.json');
  }
  getRequisitioneducationTableData() {
    // return this.http.get<GenModel>('http://10.122.72.64:8260/getPosting');
    return this.http.get<TabularModel>('./assets/json/educationTable.json');
  }
  // getDesignationData(designationId) {
  //     return this.http.get<RoleModel>(this.baseUrl+ 'getDetails/' + designationId);
  //     // return this.http.get<TabularModel>('./assets/json/educationTable.json');
  // }

  // getDigitalTags(digitalOfferId) {
  //     return this.http.get<KeyValuePair[]>(this.baseUrl+ 'getDigitalTagDetails/' + digitalOfferId);
  //     // return this.http.get<TabularModel>('./assets/json/educationTable.json');
  // }
  // getSkillByRequisitonId(id) {
  //     return this.http.get<any>(this.baseUrl+ 'getSkillMasterDetailsByRequisitonId/' + id);
  //     // return this.http.get<TabularModel>('./assets/json/educationTable.json');
  // }
  resetChip() {
    this.chipSub.next(null);
  }

  get resetChipEvent() {
    return this.chipSub.asObservable();
  }

  getReportsGenmodelNormal(url?) {
    const urlValue = url.replace('{0}', localStorage.getItem('companyHiringTypeId'));
    return this.http.get<any>(urlValue);
    // return this.http.get('./assets/json/normalReportsGenModel.json');
    // return this.http.get('http://10.86.117.61:8181/api/getGenModel?screenName=Search')
    // sushil's api
    // return this.http.get('http://10.61.110.134:8083/getSearchOptions?fieldName=Candidate_Search_Filter')
    // return this.http.get('http://10.89.236.170:8083/getSearchOptions?fieldName=Bulk Offer')
    // return this.http.get('http://10.53.121.129:8181/api/getGenModel?screenName=PH_REPORTS_FILTERS')
    // return this.http.get('http://10.61.101.93:8083/api/getSearchOptions?fieldName=Search')
  }
  getGenmodelCandidateProfile(url, reqNumber) {
    if (url) {
      const urlValue = url.replace('{0}', localStorage.getItem('companyHiringTypeId'));
      if (urlValue.includes('{1}')) {
        const urlvalue = urlValue.replace('{1}', reqNumber);
        return this.http.get(urlvalue);
      }
      return this.http.get(urlValue);
    }
    // return this.http.get('./assets/json/candidateIntapILChinaGenModel.json');
    // return this.http.get('./assets/json/candidateProfileFinal2.json');
    // return this.http.get('./assets/json/candidateProfileFinal3.json');
    //return this.http.get('./assets/json/candidateProfileECMS.json')
    // return this.http.get('./assets/json/candidateProfileECMSapi.json');
    // return this.http.get('./assets/json/candidateProfileGetECMS.json');
    // return this.http.get('http://10.217.164.62:9001/api/vendorme/getcandidateprofile/436162')
    // return this.http.get('http://10.61.110.134:8083/getSearchOptions?fieldName=Candidate_Search_Filter')
    // return this.http.get('http://10.53.109.253:8181/api/getAllCandidateProfileGenModel?screen=Candidate Profile')
    // return this.http.get('http://10.89.236.170:8083/getSearchOptions?fieldName=Bulk Offer')
    // return this.http.get('http://10.53.121.129:8181/api/getGenModel?screenName=PH_REPORTS_FILTERS')
    // return this.http.get('http://10.61.101.93:8083/api/getSearchOptions?fieldName=Search')
  }
  getGenModelProfileECMSJson() {
    // return this.http.get('./assets/json/candProfileBackend.json');
    // return this.http.get<any>('http://10.217.164.62:9001/api/vendorme/getcandidateprofile/436162')
    return this.http.get(
      'https://isgatewaytst.ad.infosys.com/infydigital/ecmsservice/api/vendorme/getcandidateprofile/436162',
    );
  }

  getECMSReportsGenModel(url) {
    const urlValue = url.replace('{0}', localStorage.getItem('companyHiringTypeId'));
    return this.http.get<any>(urlValue);
    // return this.http.get<any>('./assets/json/ecmsReportsGenModel.json');
    // return this.http.get<any>('http://10.217.164.62:9001/api/vendorme/getecmsreportsgenmodel')
    // return this.http.get<any>('https://isgatewaytst.ad.infosys.com/infydigital/ecmsspringservice/api/vendorme/getecmsreportsgenmodel/'+ this.companyHiringId)
    // return this.http.get<any>(this.baseUrlECMS + 'api/vendorme/getecmsreportsgenmodel/'+ this.companyHiringId)
  }

  submitCandidateProfile(candProfileObj) {
    console.log('envv', environment);
    return this.http.post<any>(this.baseUrlIntap + 'candidate/saveCandidate', candProfileObj);
    // return this.http.post<any>("http://10.184.32.34:8181/candidate/saveCandidate", candProfileObj);
  }

  submitCandidateProfileECMS(candProfileObj) {
    this.baseUrlECMS = environment?.ecmsPartnerHubGateWayUrl;
    return this.http.post<any>(this.baseUrlECMS + '/api/vendorme/savecandidateprofile', candProfileObj);
    // return this.http.post<any>("http://10.184.32.34:8181/candidate/saveCandidate", candProfileObj);
  }
  // fake api call
  getAPIData() {
    // return this.http.get<GenModel>('http://10.66.49.102:8080/job/getPage');
    return {
      name: 'POC',
      id: 1,
      fields: [
        {
          order: 1,
          type: 0,
          name: 'requesttitle',
          displayName: 'Request Title',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 2,
          type: 0,
          name: 'recruiterId',
          displayName: 'Recruiter ID',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 3,
          type: 0,
          name: 'hiring manager',
          displayName: 'Hiring Manager(Optional)',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 7,
          type: 11,
          name: 'Requisition Year',
          displayName: 'Requisition Year',
          inputType: 'input_type',
          value: null,
          options: [
            {
              key: 0,
              value: '2019',
              selected: false,
            },
            {
              key: 1,
              value: '2018',
              selected: false,
            },
            {
              key: 2,
              value: '2017',
              selected: false,
            },
            {
              key: 3,
              value: '2016',
              selected: false,
            },
          ],
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
      ],
    };
  }
  getReportsTable(body, url) {
    // return this.http.get<any[]>(
    //   `https://intaptest.infosysapps.com/infosys/refernow/v1/vendorReport/?FromDate=${startDate}&ToDate=${endDate}&VendorId=0600000138&CompanyHiringTypeId=${this.companyHiringId}`
    // );
    // return this.http.get<any[]>(
    //   `${url}FromDate=${startDate}&ToDate=${endDate}&VendorId=${this.vendorId}&CompanyHiringTypeId=1`
    // );
    // return this.http.get<any[]>('./assets/json/dataOnApply.json')
    return this.http.post<any[]>(url, body);
  }
  getReportsTableECMS(body, url) {
    // return this.http.post<any>(`http://10.217.164.62:9001/api/vendorme/candidatereportstable`,body)
    return this.http.post<any>(url, body);
    // return this.http.post<any>('./assets/json/ecmsReportsTable.json',{});
  }
  getComplianceGenModel() {
    // return this.http.get<any>("/assets/json/complianceTabGenModel.json")
    // return this.http.get<any>("http://10.217.164.62:9001/api/vendorme/getbgvDocUploadgenModel")
    // return this.http.get<any>(
    //   `https://isgatewaytst.ad.infosys.com/infydigital/ecmsspringservice/api/vendorme/getbgvDocUploadgenModel/${this.companyHiringId}`
    // );
    return this.http.get<any>(
      this.baseUrlECMS + `api/vendorme/getbgvDocUploadgenModel/${localStorage.getItem('companyHiringTypeId')}`,
    );
  }

  getAllUniversities() {
    return this.http.get<any>('/assets/json/universities.json');
  }
}
